import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=494f4dee&scoped=true"
import script from "./Iframe.vue?vue&type=script&lang=js"
export * from "./Iframe.vue?vue&type=script&lang=js"
import style0 from "./Iframe.vue?vue&type=style&index=0&id=494f4dee&prod&scoped=true&lang=css"
import style1 from "./Iframe.vue?vue&type=style&index=1&id=494f4dee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f4dee",
  null
  
)

export default component.exports